import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

export const containersWhere = JSON.stringify({ isNotActive: 0 });

const gqlGetValues = gql`
  query getContainertypes($where: String, $offset: Int, $limit: Int, $order: String) {
    getContainertypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
      }
      recordCount
    }
  }
`;

export function useGetContainersAsOptionsQuery() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
}

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
}

export const FieldSelectContainer = ({
  label = 'Κοντέινερ',
  name = 'containerGuid',
  defaultValues = {},
  size = 'sm',
  ...rest
}: LcFsProps) => {
  const where = JSON.stringify({ isNotActive: 0 });
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      hook={useGetContainersAsOptionsQuery}
      height={size === 'lg' ? 32 : '22'}
    />
  );
};

